import React, { useEffect, useState } from 'react';
import axiosInstance from '../../../../Services/axiosCommon';
import PDFViewer from '../../../../Components/Utils/PDFViewer';
import FilesView from '../../../../Components/Utils/FilesView';
import { TextMediumBase } from '../../../../Components/Text/MediumText';
import Pdf from '../../../../Components/Icons/Pdf';
import Txt from '../../../../Components/Icons/Txt';
import Xls from '../../../../Components/Icons/Xls';
import Doc from '../../../../Components/Icons/Doc';
import Video from '../../../../Components/Icons/Video';
import CustomAttachmentUpload from '../../../../Components/Utils/CustomFileUpload';
import { notification, Progress } from 'antd';
import { NuInput } from '../../../../Components/Utils/Input';
import NuDate from '../../../../Components/Utils/NuDate';
import moment from 'moment';
import { useFormik } from "formik";

import * as yup from 'yup';
import useFetchMataData from '../../../../Components/Hooks/useFetchMataData';
import FormikSelectTwo from '../../../../Components/Utils/Select';
import DownArrow from '../../../../Components/Icons/DownArrow';
import { MultiSelectSet } from '../../../../Components/Utils/MultiSelect';
import UseDropDown from '../../../../Components/Hooks/useDropDown';
import Breadcrumb from '../../../../Components/Utils/Breadcrumb';
import { BackButton } from '../../../../Components/Utils/Buttons';
import { useLocation, useParams } from 'react-router-dom';

function ViewTask({  id, open, fetchTasks = () => {},  }) {
  const location = useLocation();
      const task = location.state?.data;

  const [taskDetails, setTaskDetails] = useState(task || null);
  const [loading, setLoading] = useState(false);
  const [selectedFile, setSelectedFile] = useState(null);
  const [, setImage] = useState([]);
  const [api, ] = notification.useNotification();
  const { value: statusOptions,} = useFetchMataData(
    `/dropdown/dropdown-details/`,
    "Status_Task"
  );  
    const { data: user } = UseDropDown(`/user/new-drop-down`);
    console.log(user,"user");
    const {scheduleViewId} =useParams()
    

  const [comment, setComment] = useState([]);
  const [createNewComment, ] = useState({
    taskId: id,
    cmt: "",
    files: "",
  });
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectedImage, ] = useState(null);
  const [filePathList, setFilePathList] = useState([]);

  useEffect(() => {
    if (
      task?.attachments !== null &&
      task?.attachments !== "None" &&
      task?.attachments !== "[]"
    ) {
      setFilePathList(task?.attachments?.length > 0 ? task?.attachments : []);
    }
  }, [task]);

  const fetchTaskDetails = async () => {
    try {
      setLoading(true);
      const response = await axiosInstance.get(`/calendar/task/${scheduleViewId}`);
      setTaskDetails(response.data?.data);
      fetchTasks()
    } catch (error) {
      console.error("Error fetching tasks:", error);
    } finally {
      setLoading(false);
    }
  };
    
    useEffect(() => {
    
      fetchTaskDetails();
   
  }, [open, id, task]);


const [isPopupOpen, setIsPopupOpen] = useState(false);
const [isUpdating, setIsUpdating] = useState(false);

const handleSubmit = async () => {  
  setIsUpdating(true);
  
  try {
    const response = await axiosInstance.put(`/calendar/task-status/${taskDetails.id}`, {
      status: formik.values.status
    });

    if (response.status === 200 || response.data.status === true) {
      api.success({
        message: 'Status updated successfully',
        placement: "bottomRight",
      });
      fetchTaskDetails()
    } else {
      api.error({
        message: 'Status update failed',
        description: response.data.msg || "Update unsuccessful",
        placement: "bottomRight",
      });
    }
  } catch (err) {
    api.error({
      message: 'Status update failed',
      description: err.response?.data?.msg || "Network error",
      placement: "bottomRight",
    });
  } finally {
    setIsUpdating(false);
    setIsPopupOpen(false);
  }
};
const [isPopupOpenAss, setIsPopupOpenAss] = useState(false);
const [isUpdatingAss, setIsUpdatingAss] = useState(false);

const handleSubmitAssignee = async () => {
  setIsUpdatingAss(true);

  try {

    const response = await axiosInstance.put(`/schedules/assign-task/${taskDetails.id}`, {ids:formik.values.assignees});

    if (response.status === 200 || response.data.status === true) {
      api.success({
        message: 'Assignee updated successfully',
        placement: "bottomRight",
      });
      fetchTaskDetails();
    } else {
      api.error({
        message: 'Assignee update failed',
        description: response.data.msg || "Update unsuccessful",
        placement: "bottomRight",
      });
    }
  } catch (err) {
    api.error({
      message: 'Assignee update failed',
      description: err.response?.data?.msg || "Network error",
      placement: "bottomRight",
    });
  } finally {
    setIsUpdatingAss(false);
    setIsPopupOpenAss(false);
  }
};

const [selectedTask, setSelectedTask] = useState(null);
  const [, setIsTaskModalOpen] = useState(false);
  const [percentOpenTask, setPercentOpenTask] = useState(false);
   const [newCompletion, setNewCompletion] = useState(0);
 
  console.log(selectedTask, "selectedTasks");

  const handleUpdateCompletion = async () => {
    if (!taskDetails) return;

    try {
      setLoading(true);
      await axiosInstance.put(`/calendar/task-completion/${taskDetails.id}`, {
        taskCompletion: newCompletion,
      })
      setPercentOpenTask(false);
      fetchTaskDetails();

    } catch (error) {
      console.error("Error updating task completion:", error);
    } finally {
      setLoading(false);
    }
  };

  const handleChangeImg = (e) => {
    const maxFileSize = 200000000; // 200 MB
    let fileArr = [];
  
    if (e.target.files.length > 0) {
      const files = Array.from(e.target.files);
      files.map((item) => {
        if (item.size < maxFileSize) {
          fileArr.push(item);
        } else {
          api.warning({
            message: `File Size to big`,
            description: `${item.name} is Removed and not Uploaded`,
            placement: "bottomRight",
          });
        }
      });
      let tempArr = [];
      setSelectedFile(fileArr);
      files.map((item) => {
        if (item.size < maxFileSize) {
          let x = URL.createObjectURL(item);
          tempArr.push(x);
        }
      });
      setImage(tempArr);
    }
  };
  function DateDiffWithZero(createDate) {
    let exp = new Date();
    let cre = new Date(createDate);
    let timeDiff = Math.abs(exp.getTime() - cre.getTime());
    let diffDays = Math.ceil(timeDiff / (1000 * 3600 * 24));
    console.log("time", diffDays);
    return diffDays;
  }
  function NowTime(time) {
    let finalDate = DateDiffWithZero(time);
    let finalTime = `${time}+0530`;
  
    if (finalDate > 1) {
      return <NuDate value={time} format="DD-MMM-YYYY" />;
    } else {
      return moment(finalTime).fromNow();
    }
  }
  async function getComments() {
    await axiosInstance
      .get(`/Comment/task/${id}`)
      .then(async (res) => {
        console.log("bbb", res?.data?.data);
        (await res?.data?.data) && setComment(res?.data?.data);
      })
      .catch((error) => {
        console.log(error);
      });
  }
  const formik = useFormik({
    enableReinitialize: true,
    initialValues: createNewComment,
    validateOnChange: false,
    validateOnBlur: false,
    validationSchema: yup.object({
      cmt: yup.string().required("Enter Comment "),
    }),
    onSubmit: async (value, { resetForm }) => {
      let formData = new FormData();
      formData.append("data", JSON.stringify(value));
      if (selectedFile !== null) {
        selectedFile.forEach((file) => {
          formData.append("files", file);
        });
      } else {
        formData.append("files", []);
      }
      axiosInstance
        .post("/Comment/task", formData)
        .then((res) => {
          if (res.status === 201 || res.data.status == true) {
          
            resetForm();
            setSelectedFile([]);
            setImage([]);
            getComments();
           
            api.success({
              message: `Comment Display successfully`,
            
              placement: "bottomRight",
            });
          } else {
            api.error({
              message: `Comment Display failed`,
              description: res.data.msg | "Network error",
              placement: "bottomRight",
            });
          }
        })
        .catch((err) => {
          api.error({
            message: `Comment Display failed`,
            description: err?.response?.data.msg | "Network error",
            placement: "bottomRight",
          });
        });
    },
  });

 


  return (
    <>
    <div className="w-full h-full px-4 py-2 ">
        <div className="md:flex justify-between w-full ">
        <Breadcrumb
          items={[
            {
              name: "Task",
              link: `/inspection/schedule/index/${task?.scheduleId}`,
            },
            { name: "View" },
          ]}
        />  
                        <BackButton/>
      </div>
   <div className="w-full mx-auto h-[calc(100vh-175px)]  rounded-md md:overflow-hidden p-2   md:flex gap-2 text-[#111537]">
          <div className="md:w-[70%]  bg-white rounded-lg drop-shadow-lg py-1 overflow-hidden ">
            <div className="sm:w-[98%]  bg-white px-2 mx-2 border border-gray py-2 rounded-lg sm:flex justify-between items-center  z-10">
              <div className="grid  items-center px-2 w-[70%]">
                <div className="flex text-[14px] mb-1 text-[#111537] font-semibold w-[90%]">
                  <p className="flex"><p>Description</p><p> : {task?.description}</p></p>
                </div>
                <div className="flex gap-4 justify-between">
                  <p className="text-xs text-[#111537]">
                    Date :{" "}
                    {task?.dateTime ? (
                      <NuDate value={task?.dateTime} format="DD-MMM-YYYY , hh:mm A" />
                    ) : (
                      "N/A"
                    )}
                  </p>
                </div>
              </div>
              <div className="grid   justify-end w-[30%]">
              
                 <div 
    className="inline-flex items-center cursor-pointer"
    onClick={() => setIsPopupOpen(true)}
  >
    <span className="bg-white text-black px-2 py-1 text-xs rounded-l-md border border-r-0 border-[#579BB1]">
      Status
    </span>
    <span className="bg-[#579BB1] text-white px-2 py-1 text-xs rounded-r-md border border-[#579BB1]">
      {taskDetails?.status || "None"}
    </span>
  </div>
              </div>
            </div>
          


        <div className="h-[calc(100vh-220px)] overflow-y-auto p-2 pb-8 ">


<div className=" w-full h-[calc(100%-5rem)] px-2  overflow-y-auto">
{comment?.map((data, idx) => (
  <div className="py-2" key={idx}>
    <div className="flex justify-start items-center gap-2">
      <div className=" w-8 h-8 rounded-full overflow-hidden capitalize text-white font-medium flex justify-center items-center bg-[#2A475E]">
        {
              `${data?.name?.charAt(0)||"-"}`
        }
      </div>
      <p className="font-semibold text-xs text-[#707884]">
        {data?.name||""}
      </p>
      <p className="text-[#9DA3AA] text-xs font-normal ">
        {NowTime(data?.createdAt)}
      </p>
    
    </div>
     <div>
      <p className="text-xs text-[#9DA3AA] font-normal text-justify mb-3 pl-10 pr-8 pt-1">
        {data?.cmt}
      </p>
     
    </div>
  </div>
))}
</div>

<form onSubmit={formik.handleSubmit}>
<div className=" w-full ">

<div className="py-2 w-full  flex justify-between  ">
  <NuInput
               type="text"

    placeholder="Write A Comment"
    formik={formik}
    name="cmt"
    width="w-full"
  />
  <CustomAttachmentUpload
    handleChange={handleChangeImg}
    multiple={true}
   
  />
  <button type="submit" className="border-none bg-white ">
    <div className="w-6 h-6 rounded-sm  cursor-pointer mr-11">
  

      <svg
        width="16"
        height="14"
        viewBox="0 0 16 14"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className=""
      >
        <path
          d="M2.00106 13.5325C1.71412 13.6472 1.44152 13.622 1.18327 13.4567C0.925023 13.2914 0.795898 13.0513 0.795898 12.7362V9.52959C0.795898 9.32873 0.853287 9.14939 0.968065 8.99157C1.08284 8.83375 1.24066 8.73332 1.44152 8.69028L7.68256 7.14078L1.44152 5.59128C1.24066 5.54824 1.08284 5.44781 0.968065 5.28999C0.853287 5.13217 0.795898 4.95283 0.795898 4.75197V1.54537C0.795898 1.22973 0.925023 0.989273 1.18327 0.823993C1.44152 0.658713 1.71412 0.633749 2.00106 0.7491L15.2579 6.34451C15.6166 6.50233 15.7959 6.76775 15.7959 7.14078C15.7959 7.51381 15.6166 7.77923 15.2579 7.93705L2.00106 13.5325Z"
          fill="#3267FF"
        />
      </svg>
    </div>
  </button>
</div>
<div className="py-1 w-full md:w-[45%] flex gap-1">
  {selectedFile &&
    selectedFile.map((imageView) => {
      const videotype = ["mp4", "mov", "wmv", "avi", "flv", "mkv"];
      let fileExtention = imageView.name.split(".").reverse()[0];
      return (
        <div
          className=" w-32 p-1 h-10 rounded-lg  text-slate-700 text-[10px] font-medium flex gap-1  items-center"
          style={{ border: "1px solid #bfc2ca" }}
        >
          <div className=" w-9 h-9 my-2 rounded overflow-hidden flex justify-center items-center">
            {videotype.includes(fileExtention) ? <Video /> : null}

            {fileExtention == ("docx" || "doc" || "txt") ? (
              <Doc />
            ) : fileExtention == ("xlsx" || "xls") ? (
              <Xls />
            ) : fileExtention == "txt" ? (
              <Txt />
            ) : fileExtention == "pdf" ? (
              <Pdf />
            ) : (
              <img
                src={URL.createObjectURL(imageView)}
                alt="#"
                width="120%"
              />
            )}
          </div>{" "}
          <p className=" line-clamp-2 ">{imageView.name}</p>
        </div>
      );
    })}
</div>
</div>
</form>

</div>
</div>

<div className="md:w-[30%] bg-white rounded-lg drop-shadow-lg py-1 mt-3 md:mt-0">
          <div className="h-[98%] overflow-y-scroll p-2 ">
               <div className="w-full grid  border border-gary  rounded-lg">
                  <div className="bg-baseColor-primary  p-2 rounded-t-lg">
                    <p className="text-xs text-white font-medium">
                      Assignee
                    </p>
                  </div>
                  <div className=" border border-gary  overflow-y-scroll h-28 rounded-b-lg p-2">
                  <div className='w-full flex px-2 '>
                    <>
                   
                    {taskDetails?.assignees?.length > 0 ? (
                          <div className="flex flex-wrap gap-1">
                            {taskDetails?.assignees.map((assignee, index) => (
                              <span
                                key={index}
                                className="inline-block bg-gray-100 rounded-full px-2 py-0.5 text-xs text-gray-700"
                              >
                                {assignee?.assigneeName || `Assignee ${index + 1}`}
                              </span>
                            ))}
                          </div>
                        ) : (
                          <span className="text-gray-400 text-xs">Unassigned</span>
                        )}
                        <div className=''  onClick={() => setIsPopupOpenAss(true)}>
                          <DownArrow />
                          </div>
                        </>
                </div>

               </div>
               </div>
               <div className="w-full grid mt-4 border border-gary  rounded-lg">
                  <div className="bg-baseColor-primary  p-2 rounded-t-lg">
                    <p className="text-xs text-white font-medium">
                      Progress
                    </p>
                  </div>
                  <div className=" border border-gary items-center text-center overflow-y-scroll h-28 rounded-b-lg p-2">
                 <Progress
                                          onClick={() => {
                                            setSelectedTask(taskDetails);
                                            setNewCompletion(taskDetails.taskCompletion || 0);
                                            setPercentOpenTask(true);
                                          }}
                                          type="circle"
                                          size={70}
                                          strokeWidth={12}
                                          format={(percent) => (
                                            <span
                                              className={`cursor-pointer ${
                                                percent > 95
                                                  ? "text-[#87d068]"
                                                  : percent > 50
                                                  ? "text-[#108ee9]"
                                                  : "text-[#D2BD00]"
                                              } text-xs font-semibold`}
                                            >
                                              {percent}%
                                            </span>
                                          )}
                                          percent={
                                            typeof taskDetails?.taskCompletion === "number"
                                              ? taskDetails?.taskCompletion
                                              : 0
                                          }
                                          strokeColor={
                                            (taskDetails?.taskCompletion || 0) > 95
                                              ? { "0%": "#87d068", "100%": "#87d068" }
                                              : (taskDetails?.taskCompletion || 0) > 50
                                              ? { "0%": "#108ee9", "100%": "#108ee9" }
                                              : { "0%": "#D2BD00", "100%": "#D2BD00" }
                                          }
                                        />
               </div>
               </div>
               <div className="w-full grid mt-4 border border-gary  rounded-lg">
               <div className=" ">
              <div className="bg-baseColor-primary  p-2 rounded-t-lg">
                    <p className="text-xs text-white font-medium">
                    Attachments
                </p>
                </div>
                <div className=" border border-gary  overflow-y-scroll h-28 rounded-b-lg p-2">
                  <div className="w-full flex gap-2 flex-wrap ">
                    {taskDetails?.attachments &&
                      filePathList.map((imgs, idx) => {
                        console.log("img", imgs);
                        return <FilesView fileView={imgs} key={idx} />;
                      })}
                  </div>
                </div>
              </div>
            </div>
           
            </div>
            </div>
            </div>
    {isModalOpen &&
    <div className="fixed top-0 left-0 w-full h-full bg-gray-800 bg-opacity-50 z-[9999] flex justify-center items-center">
    <div className="animate-scale-in min-w-[96%] max-w-[100%] h-[90%] bg-white py-4 px-6 rounded-md shadow-lg overflow-y-scroll">
            <div className='px-[3%] mx-auto flex justify-between pt-5'>
                <TextMediumBase content={"Attachment View"} />
                <div className='w-6 h-6 rounded-md bg-baseColor-secondary cursor-pointer' onClose={() => setIsModalOpen(false)}>
                    <p className='text-white text-xs text-center py-1'>X</p>
                </div>
            </div>
            <div className="m-4 overflow-y-scroll h-full flex justify-center ">
            {selectedImage?.file.split(".").reverse()[0] == "pdf" ? (
          <PDFViewer pdfFile={selectedImage?.file} />
        ) : (
          <img src={selectedImage?.file} alt={selectedImage?.file} />
        )}
            </div>
          </div>
        </div>
}
    {isPopupOpen && (
    <div className="fixed top-0 left-0 w-full h-full bg-gray-800 bg-opacity-50 z-[9999] flex justify-center items-center">
    <div className="animate-scale-in min-w-[40%] max-w-[60%] max-h-[40%] bg-white py-4 px-6 rounded-md shadow-lg overflow-y-scroll">
         <h3 className="font-medium mb-3">Update Status</h3>
        
        <div className="space-y-2 mb-4">
        <FormikSelectTwo
              label="Status"
              Options={statusOptions}
              formik={formik}
              placeholder="Choose"
              name="status"           
              width="w-full "
            />
         
        </div>

        <div className="flex justify-end space-x-2">
          <button 
            className="px-3 py-1 text-sm text-gray-600 border-baseColor-primary rounded-md hover:text-gray-800"
            onClick={() => setIsPopupOpen(false)}
            disabled={isUpdating}
          >
            Cancel
          </button>
          <button
            className="px-3 py-1 text-sm bg-baseColor-primary text-white rounded-md hover:bg-[#468399] disabled:opacity-50"
            onClick={handleSubmit}  
            disabled={isUpdating}
          >
            {isUpdating ? 'Updating...' : 'Update'}
          </button>
        </div>
      </div>
    </div>
  )}

{isPopupOpenAss && (
    <div className="fixed top-0 left-0 w-full h-full bg-gray-800 bg-opacity-50 z-[9999] flex justify-center items-center">
    <div className="animate-scale-in min-w-[40%] max-w-[60%] max-h-[50%] bg-white py-4 px-6 rounded-md shadow-lg overflow-y-scroll">
         <h3 className="font-medium mb-3">Update Assignee</h3>
        
        <div className="space-y-2 mb-4">
         <MultiSelectSet
                               label="Assignee"
                                             type="text"
                                             Options={user}
                                             placeholder="Choose Assignee"
                                             isMulti={true}
                                             formik={formik}
                                             name="assignees"
                                             width="w-full"
                                             FixPosition={true}
                                             PortalTarget={false}
                                           />
         
        </div>

        <div className="flex justify-end space-x-2">
          <button 
            className="px-3 py-1 text-sm text-gray-600 border border-baseColor-primary rounded-md hover:text-gray-800"
            onClick={() => setIsPopupOpenAss(false)}
            disabled={isUpdatingAss}
          >
            Cancel
          </button>
          <button
            className="px-3 py-1 text-sm bg-baseColor-primary text-white rounded-md hover:bg-[#468399] disabled:opacity-50"
            onClick={handleSubmitAssignee}  
            disabled={isUpdatingAss}
          >
            {isUpdatingAss ? 'Updating...' : 'Update'}
          </button>
        </div>
      </div>
    </div>
  )}

{percentOpenTask && (
        <div className="fixed top-0 left-0 w-full h-full bg-gray-800 bg-opacity-50 z-[9999] flex justify-center items-center">
          <div className="animate-scale-in min-w-[40%] max-w-[90%] max-h-[80vh] bg-white py-4 px-6 rounded-md shadow-lg overflow-y-auto">
            <div className="flex justify-between items-center mb-4">
              <h3 className="text-lg font-semibold">Update Task Completion</h3>
              <button
                onClick={() => setPercentOpenTask(false)}
                className="text-gray-500 hover:text-gray-700"
              >
                ×
              </button>
            </div>

            <div className="mb-4">
              <label className="block text-sm font-medium text-gray-700 mb-1">
                Task Percentage
              </label>
              <div className="flex items-center gap-2">
                <input
                  type="number"
                  className="w-full p-2 border rounded focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                  value={newCompletion}
                  onChange={(e) => {
                    const value = parseInt(e.target.value);
                    if (!isNaN(value) && value >= 0 && value <= 100) {
                      setNewCompletion(value);
                    }
                  }}
                  min={0}
                  max={100}
                  placeholder="0"
                />
                <span>%</span>
              </div>
            </div>

            <div className="flex justify-end gap-2">
              <button
                onClick={() => setPercentOpenTask(false)}
                className="px-4 py-2 text-sm text-gray-700 bg-gray-100 rounded hover:bg-gray-200"
              >
                Cancel
              </button>
              <button
                onClick={handleUpdateCompletion}
                disabled={loading}
                className="px-4 py-2 text-sm text-white bg-blue-600 rounded hover:bg-blue-700 disabled:opacity-50"
              >
                {loading ? "Updating..." : "Update"}
              </button>
            </div>
          </div>
        </div>
      )}
      </div>
    {isModalOpen &&
    <div className="fixed top-0 left-0 w-full h-full bg-gray-800 bg-opacity-50 z-[9999] flex justify-center items-center">
    <div className="animate-scale-in min-w-[96%] max-w-[100%] h-[90%] bg-white py-4 px-6 rounded-md shadow-lg overflow-y-scroll">
            <div className='px-[3%] mx-auto flex justify-between pt-5'>
                <TextMediumBase content={"Attachment View"} />
                <div className='w-6 h-6 rounded-md bg-baseColor-secondary cursor-pointer' onClose={() => setIsModalOpen(false)}>
                    <p className='text-white text-xs text-center py-1'>X</p>
                </div>
            </div>
            <div className="m-4 overflow-y-scroll h-full flex justify-center ">
            {selectedImage?.file.split(".").reverse()[0] == "pdf" ? (
          <PDFViewer pdfFile={selectedImage?.file} />
        ) : (
          <img src={selectedImage?.file} alt={selectedImage?.file} />
        )}
            </div>
          </div>
        </div>
}
    {isPopupOpen && (
    <div className="fixed top-0 left-0 w-full h-full bg-gray-800 bg-opacity-50 z-[9999] flex justify-center items-center">
    <div className="animate-scale-in min-w-[40%] max-w-[60%] max-h-[40%] bg-white py-4 px-6 rounded-md shadow-lg overflow-y-scroll">
         <h3 className="font-medium mb-3">Update Status</h3>
        
        <div className="space-y-2 mb-4">
        <FormikSelectTwo
              label="Status"
              Options={statusOptions}
              formik={formik}
              placeholder="Choose"
              name="status"           
              width="w-full "
            />
         
        </div>

        <div className="flex justify-end space-x-2">
          <button 
            className="px-3 py-1 text-sm text-gray-600 border-baseColor-primary rounded-md hover:text-gray-800"
            onClick={() => setIsPopupOpen(false)}
            disabled={isUpdating}
          >
            Cancel
          </button>
          <button
            className="px-3 py-1 text-sm bg-baseColor-primary text-white rounded-md hover:bg-[#468399] disabled:opacity-50"
            onClick={handleSubmit} 
            disabled={isUpdating}
          >
            {isUpdating ? 'Updating...' : 'Update'}
          </button>
        </div>
      </div>
    </div>
  )}

{isPopupOpenAss && (
    <div className="fixed top-0 left-0 w-full h-full bg-gray-800 bg-opacity-50 z-[9999] flex justify-center items-center">
    <div className="animate-scale-in min-w-[40%] max-w-[60%] max-h-[50%] bg-white py-4 px-6 rounded-md shadow-lg overflow-y-scroll">
         <h3 className="font-medium mb-3">Update Assignee</h3>
        
        <div className="space-y-2 mb-4">
         <MultiSelectSet
                               label="Assignee"
                                             type="text"
                                             Options={user}
                                             placeholder="Choose Assignee"
                                             isMulti={true}
                                             formik={formik}
                                             name="assignees"
                                             width="w-full"
                                             FixPosition={true}
                                             PortalTarget={false}
                                           />
         
        </div>

        <div className="flex justify-end space-x-2">
          <button 
            className="px-3 py-1 text-sm text-gray-600 border border-baseColor-primary rounded-md hover:text-gray-800"
            onClick={() => setIsPopupOpenAss(false)}
            disabled={isUpdatingAss}
          >
            Cancel
          </button>
          <button
            className="px-3 py-1 text-sm bg-baseColor-primary text-white rounded-md hover:bg-[#468399] disabled:opacity-50"
            onClick={handleSubmitAssignee}  
            disabled={isUpdatingAss}
          >
            {isUpdatingAss ? 'Updating...' : 'Update'}
          </button>
        </div>
      </div>
    </div>
  )}

{percentOpenTask && (
        <div className="fixed top-0 left-0 w-full h-full bg-gray-800 bg-opacity-50 z-[9999] flex justify-center items-center">
          <div className="animate-scale-in min-w-[40%] max-w-[90%] max-h-[80vh] bg-white py-4 px-6 rounded-md shadow-lg overflow-y-auto">
            <div className="flex justify-between items-center mb-4">
              <h3 className="text-lg font-semibold">Update Task Completion</h3>
              <button
                onClick={() => setPercentOpenTask(false)}
                className="text-gray-500 hover:text-gray-700"
              >
                ×
              </button>
            </div>

            <div className="mb-4">
              <label className="block text-sm font-medium text-gray-700 mb-1">
                Task Percentage
              </label>
              <div className="flex items-center gap-2">
                <input
                  type="number"
                  className="w-full p-2 border rounded focus:ring-2 focus:ring-blue-500 focus:border-blue-500"
                  value={newCompletion}
                  onChange={(e) => {
                    const value = parseInt(e.target.value);
                    if (!isNaN(value) && value >= 0 && value <= 100) {
                      setNewCompletion(value);
                    }
                  }}
                  min={0}
                  max={100}
                  placeholder="0"
                />
                <span>%</span>
              </div>
            </div>

            <div className="flex justify-end gap-2">
              <button
                onClick={() => setPercentOpenTask(false)}
                className="px-4 py-2 text-sm text-gray-700 bg-gray-100 rounded hover:bg-gray-200"
              >
                Cancel
              </button>
              <button
                onClick={handleUpdateCompletion}
                disabled={loading}
                className="px-4 py-2 text-sm text-white bg-blue-600 rounded hover:bg-blue-700 disabled:opacity-50"
              >
                {loading ? "Updating..." : "Update"}
              </button>
            </div>
          </div>
        </div>
      )}
    </>
  );
}

export default ViewTask;